<template>
	<section class="faq" :style="sectionVars">
		<div class="container">
			<h2 v-if="title" class="faq__title headline-l">{{ title }}</h2>

			<div class="faq__list">
				<accordion
					v-for="(item, i) in items"
					:key="i"
					class="faq__item"
					:iconMask="iconMask"
					:iconMaskOpen="iconMaskOpen"
					:iconColor="borderColor"
					:iconWidth="'32px'"
					:iconHeight="'32px'"
					:rotateIconOnOpen="false"
				>
					<template v-slot:header>
						<span class="faq__question">{{ item.question }}</span>
					</template>
					<div class="faq__answer" v-html="item.answer"></div>
				</accordion>
			</div>

			<p v-if="prompt" class="faq__prompt">{{ prompt }}</p>

			<div v-if="buttonText" class="faq__cta">
				<base-button
					:text="buttonText"
					size="large"
					type="light-green"
					@clicked="$emit('contactClicked')"
				/>
			</div>
		</div>
	</section>
</template>

<script>
export default {
	name: 'FaqSection',
	props: {
		title: { type: String, default: '' },
		// [{ question, answer }] -- answer is v-html
		items: { type: Array, default: () => [] },
		prompt: { type: String, default: '' },
		buttonText: { type: String, default: '' },
		iconMask: { type: String, default: '/images/icons/plus.svg' },
		iconMaskOpen: { type: String, default: '/images/icons/minus.svg' },
		backgroundColor: { type: String, default: '#E8E8FF' },
		titleColor: { type: String, default: '#050535' },
		textColor: { type: String, default: '#262A52' },
		borderColor: { type: String, default: '#6464FF' },
	},
	components: {},
	data: () => ({}),
	created() {},
	computed: {
		sectionVars() {
			return {
				'--bg': this.backgroundColor,
				'--title-color': this.titleColor,
				'--text-color': this.textColor,
				'--border': this.borderColor,
			};
		},
	},
	methods: {},
};
</script>

<style lang="scss" scoped>
.faq {
	background: var(--bg);
	padding: 90px 0;

	@media (max-width: $breakpoint-sm) {
		padding: 50px 0;
	}
}

.faq__title {
	color: var(--title-color);
	text-transform: uppercase;
	margin-bottom: 40px;

	@media (max-width: $breakpoint-sm) {
		text-align: center;
		margin-bottom: 30px;
	}
}

.faq__item {
	border: 1px solid var(--border);
	padding: 12px 20px;
	margin-bottom: 14px;

	// closed height in the design
	&::v-deep .header-part {
		min-height: 38px;
	}

	&:last-child {
		margin-bottom: 0;
	}
}

.faq__question {
	color: var(--text-color);
	font-size: $text-l;
	line-height: 24px;
}

.faq__answer {
	color: var(--text-color);
	font-size: $text-m;
	line-height: 22px;
	padding-top: 14px;
}

.faq__prompt {
	color: var(--text-color);
	font-size: $text-m;
	line-height: 22px;
	text-align: center;
	margin-top: 40px;
}

.faq__cta {
	display: flex;
	justify-content: center;
	margin-top: 24px;

	// full-bleed call to action once stacked, as the rest of the page does
	@media (max-width: $breakpoint-sm) {
		&::v-deep .default {
			width: 100%;
		}
	}
}
</style>
